

(function($){
    /**
     * Legend component, child of $.OSD
     * initializes instances of LegendButton if found at the moment the DOM is loaded
     */
    $.Legend = function() {
        this._component_name = "legend";
        this._legend_buttons = [];
    };

    $.Component.create($.Legend, {
        _init_: function(options) {
            this._options = options || {};
            this._selector = this._options.selector || ".legend-button";
            ABDOUtil._on_dom_loaded(this._on_dom_content_loaded.bind(this));
        },
        
        _on_dom_content_loaded: function() {
            var legend_buttons = document.querySelectorAll(this._selector);

            var i, legend_buttons_n= legend_buttons.length;
    
            for (i = 0; i < legend_buttons_n; i++) {
                this._legend_buttons.push(new $.LegendButton(legend_buttons[i])); 
            }
            this._emit(this._events.ready);
        }
    }, $.OSD);

    /**
     * LegendButton class
     */
    $.LegendButton = function(button) {
        // receive id or queryselector 
        if (typeof(button) === 'string') {
            var element = document.getElementById(button);
            if (element == null) {
                element = document.querySelector(button);
            }
            this._button = element;
        }
        else if (typeof(button) === 'object') {
            this._button = button;
        }
        
    
        if (typeof(this._button) !== 'undefined' && this._button != null) {
            if ('legendSrc' in this._button.dataset) {
                this._image_source = this._button.dataset.legendSrc;
            }
        }
    
        this._button.addEventListener('click', this.click.bind(this));
    
        this._legend_modal = this._getModal();
        this._legend_image = null;
        if (this._legend_modal != null) {
            this._legend_image = this._legend_modal.querySelector('.legend-image');
            this._legend_modal.addEventListener('click',  this.modalClick.bind(this));
        }
    }; 

    $.LegendButton.prototype = {
        click: function(evt) {
            this._getModal();
            if (this._legend_modal != null) {
                var legend_image = this._legend_modal.querySelector('.legend-image');
                legend_image.src = this._image_source;
    
                jQuery(this._legend_modal).modal('toggle');
            }
        },
    
        modalClick: function(evt) {
            this._getModal();
            if (this._legend_modal != null) { // should be always true though
                jQuery(this._legend_modal).modal('hide');
            }
        }, 
    
        _getModal: function() {
            if (this._legend_modal == null) {
                var modal = document.querySelector('#legendModal');
                if (modal != null) {
                    modal.addEventListener('click',  this.modalClick.bind(this));
                    this._legend_modal = modal;
                } 
            }
        },
    }; 

})(ABDOMap);